import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;

// todo onChange={onChangeExecutorsOrder} value={filter.executors}
const Executors = ({ form, executors }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Исполнитель:">
      {getFieldDecorator('executors')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите исполнителя"
          allowClear={true}
          mode="multiple"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {executors &&
            executors.map(executor => (
              <Option key={executor.id}>{executor.name}</Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default Executors;
